import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpContextToken } from '@angular/common/http';
import type { HttpEvent } from '@angular/common/http';
import { catchError, EMPTY, Observable } from 'rxjs';
import { MessageService } from 'primeng/api';

export const BFF_REQUEST = new HttpContextToken(() => false);

@Injectable()
export class BffErrorInterceptor implements HttpInterceptor {
  constructor(private readonly messageService: MessageService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(BFF_REQUEST)) {
      return next.handle(request).pipe(
        catchError(() => {
          this.messageService.add({
            severity: 'error',
            sticky: true,
            summary: 'Er is iets misgegaan',
            detail:
              'Probeer het later nog eens. Blijft het probleem zich voordoen? Neem dan contact op met de klantenservice.',
          });
          return EMPTY;
        }),
      );
    }

    return next.handle(request);
  }
}
